export default __webpack_public_path__ + "static/media/doctor-icon.ab67f27a.svg";